module.exports = __webpack_public_path__ + "static/media/photo4@2x.ad5b7045.jpg";